<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false"
      :hide-separators="true"
      :title="program && program.is_amenagement ? 'Édition du lotissement' : 'Édition du programme'"
      :subtitle="`${p ? p.name : ''}`">
    </page-nav-bar>
    <program-form
      :source-program="p"
      :source-loading="loading"
      @submit="updateProgram"
      @updateSources="updateSources"></program-form>
  </div>
</template>

<script>
import ProgramMixin from './ProgramMixin'

export default {
  name: 'ProgramEdit',
  components: {
    ProgramForm: () => import('@/components/programs/ProgramForm')
  },
  mixins: [ProgramMixin],
  data () {
    return {
      isParent: true
    }
  }
}
</script>
